import React, { useEffect, useState } from 'react';
import { getRouteApi } from '../api/initialApis';
import { Container } from 'olive-react-myoneui';
import axios from '../utils/axios';
import { useParams } from 'react-router-dom';
import { API_URL, headers } from '../constants/config';
import CourseCurriculum from '../components/student-dashboard/course-curriculum';
import BundleItems from '../components/student-dashboard/bundle-items';
import CourseEvents from '../components/student-dashboard/event-listing';
import BmsEventDetail from '../components/student-dashboard/event-inner';
import Custom_page from '../components/Page/Custom_page';
import Footer from '../components/Footer';
import TopHeader from '../components/TopHeader';
import NavigationBarStudentLanding from '../components/NavigationBarStudentLanding';
import { getCache } from "../components/Page/utils/cacheManager";
import { useSelector, useDispatch } from "react-redux";
import { setSeconds } from 'date-fns';
import Error404 from "../modules/Error404"
import Spinner from 'olive-react-myoneui/lib/Spinner';
import { setUserItemApprovalData } from '../reducers/userItemApprovalSlice';
import IaminterestedModal from '../components/student-dashboard/IamInterestedModal';

function Slug() {
  let { slug } = useParams();
  const [url, setUrl] = useState('');
  const [route, setRoute] = useState('');
  const [routelist, setRouteList] = useState('');
  const [type, setType] = useState('');
  const [coursedetails, setCourseDetails] = useState(null);
  const [courseId, setCourseId] = useState([]);
  const [redirect,setRedirect] = useState(false);
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const bulk_purchase = miscellaneous.bulk_purchase;
  let data_version = localStorage.getItem("data_version");
  const [errorpage,setErrorpage] = useState(false);
  const showIamInterestedModal = useSelector((state) => state.userItemApproval.showIamInterestedModal);
  const dispatch = useDispatch();

  let routenew = ""
   
  const getRoutes = async () => {
    var myHeaders = new Headers();
    //myHeaders.append('pragma', 'force-cache');
    myHeaders.append('cache-control', 'force-cache');
    var myInit = {
      method: 'GET',
      headers: myHeaders,
    };
    const res = await fetch(`${API_URL}api/front_end/getRoute.json?v=${data_version}`, myInit);
    //const res = await fetch(`${API_URL}assets/course.json`,myInit);
    const response = await res.json(); 
    setRouteList(response.data);
    return response;
  }

  const fetchPosts = async () => {
    const route_cache =  await getCache("all_routes",getRoutes, {}, 2592000);
    setRouteList(route_cache.data)
  };

  
  const fetchCourseDetails = async (routenew) => {
    if(routenew){
      const course_cache = await getCache("slug~"+slug,courseDetailApi, routenew, 45000);
      setCourseDetails(course_cache);
      if (course_cache && course_cache?.current_currency && localStorage.getItem('current_currency') == null){
        localStorage.setItem('current_currency', JSON.stringify(course_cache?.current_currency));
      } else {
        const previous_currency = localStorage.getItem('current_currency') ? JSON.parse(localStorage.getItem('current_currency')) : '';
        if (course_cache?.current_currency?.symbol_code !== previous_currency?.symbol_code){
          localStorage.setItem('current_currency', JSON.stringify(course_cache?.current_currency));
        }
      }
      document.querySelector(".mk-page-loader").style.display = 'none'
      if(bulk_purchase == false && course_cache?.already_subscribed == true){
          window.location.href = `course/dashboard/${course_cache?.course_id}`
          return
      }
      setRedirect(true);
    }
  }

  const courseDetailApi = async (routenew) => {
    if (routenew) {
        try {
          var origin = window.location.origin;
          const headers = {
            'Content-Type': 'application/json',
            //'Authorization': `Bearer ${configData.access_token}`
          }
          return await fetch(API_URL + `api/${routenew}?v=${data_version}`)
          .then((response) => response.json())
          .then((response) => {
            setCourseDetails(response);
            return response;
          });
        } catch (error) {
          console.log('Init Error', error);
        }
      
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);


  useEffect(() => {
    if (routelist.length > 0) { 
      slug = slug ?? 'home-page'; 
      let newslug = findArrayElementByTitle(routelist, slug);
      if (newslug) {
        setCourseId(newslug.id);
        setRoute(newslug.route);
        routenew = newslug.route;
        setType(newslug.r_item_type);
        fetchCourseDetails(routenew);
      }
      else{
        setType("404");
      }
    }
  }, [routelist,slug]);

  useEffect(()=>{
    fetchUserItemApprovals();
  },[routelist,slug]);

  const fetchUserItemApprovals = async () => {
    const response = await axios.post(`${API_URL}api/front_end/list_user_item_approvals`);
    const approvalItemIds = response.data.data.map((item) => item.uia_item_id);
    dispatch(setUserItemApprovalData({ existingApprovalIds : approvalItemIds}));
}

  function findArrayElementByTitle(array, title) {
    return (
      Array.isArray(array) ? array.find((element) => {
        return element.slug === title;
      }):0
    );
  }


  return (
    <div> 
      <TopHeader />
      <NavigationBarStudentLanding />
      {/* <div className="w-100 p-4"> */}
      {/* <Container> */}

      {type == 'course' && redirect == true && (
        <CourseCurriculum
          key="1"
          coursedetails={coursedetails}
        />
      )}
      {type == 'bundle' && (
        <BundleItems
          key="2"
          coursedetails={coursedetails}
        />
      )}
      {type == 'bms_course' && (
        <CourseEvents
          key="3"
          coursedetails={coursedetails}
        />
      )}
      {type == 'bms_event' && (
        <BmsEventDetail
          key="4"
          coursedetails={coursedetails}
        />
      )}
       {type == 'page' && (
        <Custom_page
          key="5"
          page_details={coursedetails}
        />
      )}
       {type == '404' && (
        <Error404
         
        />
      )}
      <div className="mk-page-loader">
      <div className="mk-page-loader-wrapper">
        <Spinner animation="border" variant="primary" />
        <h1>Loading... Please wait.</h1>
      </div>
    </div>
      <Footer />
     
      <IaminterestedModal
        show={showIamInterestedModal}
        onHide={() => dispatch(setUserItemApprovalData({showIamInterestedModal : false}))}
        successTitle={"Are you sure want to continue? This will create the interest in this course and line managers must approve your request"}
        successMessage={''}
      />
    </div>
  );
}

export default Slug;
